<template>
  <div
    class="saas-section"
    :class="[
      {
        'saas-section--light-to-dark':
          block.background_gradient == 'light_to_dark',
        'saas-section--dark-to-light':
          block.background_gradient == 'dark_to_light',
      },
    ]"
  >
    <div
      v-if="block.title"
      class="saas-section__title saas-section__title--wide"
    >
      <h2 class="saas-striped-title">{{ block.title }}</h2>
    </div>
    <div v-if="block.description" class="saas-section__description">
      {{ block.description }}
    </div>
    <div class="page-single-comparison__container">
      <div class="page-single-comparison">
        <div class="page-single-comparison__product">
          <div class="page-single-comparison__image">
            <img
              class="page-single-comparison__image-img"
              src="@baserow/modules/core/static/img/logo.svg"
              alt="Baserow logo"
              loading="lazy"
            />
          </div>
          <div class="page-single-comparison__usps">
            <div
              v-for="(usp, index) in block.baserow_points"
              :key="index"
              class="page-single-comparison__usp"
            >
              <i
                class="page-single-comparison__usp-icon iconoir-check-circle"
              ></i>
              {{ usp }}
            </div>
          </div>
        </div>
        <div
          class="page-single-comparison__product page-single-comparison__product--second"
        >
          <div class="page-single-comparison__image">
            <img
              v-if="block.logo"
              class="home-v2-compare__vs-product-logo-image"
              :src="block.logo.logo.src"
              loading="lazy"
            />
          </div>
          <div class="page-single-comparison__usps">
            <div
              v-for="(usp, index) in block.competitor_points"
              :key="index"
              class="page-single-comparison__usp"
            >
              <i class="page-single-comparison__usp-icon iconoir-cancel"></i>
              {{ usp }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBlockSingleComparison',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
